import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer, REHYDRATE } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './reducers';
import rootSaga from './sagas';

// Create saga middleware
const sagaMiddleware = createSagaMiddleware();

// Wrap root reducer to handle persistence
const persistenceReducer = (state, action) => {
  // Handle initial state
  if (!state) {
    return rootReducer(undefined, action);
  }

  // Handle rehydration
  if (action.type === REHYDRATE && action.key === 'root') {
    const currentPath = window.location.pathname;

    const wizardLaunchInitialState = {
      activeStep: 0,
      courseDetails: null,
      cdlType: null,
      endorsements: null,
      moreClassSelection: [],
      stateSelection: null,
      videoSelection: null,
      courseRecommendation: null,
      screenData: {
        'course-selection': null,
        select: null,
        endorsements: null,
        video: null,
        recommend: null,
        cdl_type: null,
      },
      dynamicData: null,
      dynamicDataLoading: false,
      dynamicDataError: null,
      navigationPath: null,
      currentStep: null,
      previousStep: null,
      steps: ['', '', '', '', ''],
      isBackNavigation: false,
      navigationHistory: [],
      isManualBackNavigation: false,
    };
    const cartInitialState = {
      error: '',
      loading: false,
      message: '',
      coupon: null,
      cartItems: [],
      subtotal: 0,
      discount: 0,
      total: 0,
      isPurchasing: false,
      purchaseError: null,
      purchaseSuccess: false,
      stripePaymentLoading: false,
      stripePaymentError: null,
      paymentIntent: null,
    };
    const userInitialState = {
      error: '',
      loading: false,
      message: '',
      userInfo: {},
      profileInfo: {},
      isUserLoggedIn: false,
    };

    // If on base route, use initial state
    if (currentPath === '/') {
      return {
        ...state,
        wizardLaunch: wizardLaunchInitialState,
        cart: cartInitialState,
        user: userInitialState,
      };
    }

    // For all other routes, if we have rehydrated data, merge it properly
    if (action.payload) {
      return {
        ...state,
        ...action.payload,
        wizardLaunch: action.payload.wizardLaunch
          ? {
              ...wizardLaunchInitialState,
              ...action.payload.wizardLaunch,
            }
          : wizardLaunchInitialState,
        cart: action.payload.cart
          ? {
              ...cartInitialState,
              ...action.payload.cart,
            }
          : cartInitialState,
        user: action.payload.user
          ? {
              ...userInitialState,
              ...action.payload.user,
            }
          : userInitialState,
      };
    }
  }

  // For all other actions, use root reducer
  return rootReducer(state, action);
};

// Configure persist options
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['cart', 'wizardLaunch', 'user'],
};

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, persistenceReducer);

// Create enhancer with middleware and DevTools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(applyMiddleware(sagaMiddleware));

// Create store
const store = createStore(persistedReducer, enhancer);

// Run saga middleware
sagaMiddleware.run(rootSaga);

// Create persistor
export const persistor = persistStore(store);

export default store;
